
/*
* this file collects used
* data-testid
* elements to make sure, they are used unique and to avoid double usage
* and to use them in components as well as in tests
 */

export const TESTID_FOLLOWBUTTON_FOLLOWERCOUNT = "follower_count"